import { render, staticRenderFns } from "./selectLinkage.vue?vue&type=template&id=bbb2dbbc&scoped=true&"
import script from "./selectLinkage.vue?vue&type=script&lang=js&"
export * from "./selectLinkage.vue?vue&type=script&lang=js&"
import style0 from "./selectLinkage.vue?vue&type=style&index=0&id=bbb2dbbc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb2dbbc",
  null
  
)

export default component.exports